const formatDate = (data): Date | string => {
  return new Date(data).toISOString();
};

export default formatDate;
